import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	SHARE: {
		path: 'share',
		method: 'POST'
	},
	CALCULATE_CUSTOM_PRODUCT_PRICE: {
		path: 'custom-product-price/{c_productId}',
		method: 'POST'
	}
};

export interface IShareProductOptions extends IBaseFetchOptions {
	body: {
		languageCode?: string;
		countryCode?: string;
		senderName: string;
		senderEmail: string;
		friendName: string;
		friendEmail: string;
		message?: string;
		productID: string;
		productSize?: string;
		productColor?: string;
	};
}

export interface ICalculateCustomProductPriceOptions extends IBaseFetchOptions {
	body: object;
}

export interface IShareProductResponse extends IBaseResponse {
	message: string
}

export interface ICalculateCustomProductPriceResponse extends IBaseResponse {
	customPrice: number;
}
